import { centsToMoney, moneyToCents } from "../finance";

export const COLLECTION_CONTRIBUTION_MODE = Object.freeze({
  FIXED: "fixed",
  FLEXIBLE_RANGE: "flexible_range",
});

export const COLLECTION_CONTRIBUTION_ERROR = Object.freeze({
  MIN_REQUIRED: "MIN_REQUIRED",
  MIN_BELOW_ONE_ZLOTY: "MIN_BELOW_ONE_ZLOTY",
  MAX_REQUIRED: "MAX_REQUIRED",
  MAX_BELOW_MIN: "MAX_BELOW_MIN",
  AMOUNT_INVALID: "AMOUNT_INVALID",
  AMOUNT_BELOW_MIN: "AMOUNT_BELOW_MIN",
  AMOUNT_ABOVE_MAX: "AMOUNT_ABOVE_MAX",
});

export function getCollectionContributionConfig(collection = {}) {
  const contributionMode =
    collection.contribution_mode === COLLECTION_CONTRIBUTION_MODE.FLEXIBLE_RANGE
      ? COLLECTION_CONTRIBUTION_MODE.FLEXIBLE_RANGE
      : COLLECTION_CONTRIBUTION_MODE.FIXED;
  return {
    contributionMode,
    isVoluntary: collection.is_voluntary === true,
    minContribution:
      contributionMode === COLLECTION_CONTRIBUTION_MODE.FLEXIBLE_RANGE
        ? centsToMoney(moneyToCents(collection.min_contribution))
        : null,
    maxContribution:
      contributionMode === COLLECTION_CONTRIBUTION_MODE.FLEXIBLE_RANGE
        ? centsToMoney(moneyToCents(collection.max_contribution))
        : null,
  };
}

export function validateCollectionContributionConfig({
  contributionMode = COLLECTION_CONTRIBUTION_MODE.FIXED,
  isVoluntary = false,
  minContribution = null,
  maxContribution = null,
} = {}) {
  if (contributionMode !== COLLECTION_CONTRIBUTION_MODE.FLEXIBLE_RANGE) {
    return {
      valid: true,
      contributionMode: COLLECTION_CONTRIBUTION_MODE.FIXED,
      isVoluntary: Boolean(isVoluntary),
      minContribution: null,
      maxContribution: null,
    };
  }

  const minCents = moneyToCents(minContribution);
  const maxCents = moneyToCents(maxContribution);
  if (minCents === null) return { valid: false, error: COLLECTION_CONTRIBUTION_ERROR.MIN_REQUIRED };
  if (minCents < 100) return { valid: false, error: COLLECTION_CONTRIBUTION_ERROR.MIN_BELOW_ONE_ZLOTY };
  if (maxCents === null) return { valid: false, error: COLLECTION_CONTRIBUTION_ERROR.MAX_REQUIRED };
  if (maxCents < minCents) return { valid: false, error: COLLECTION_CONTRIBUTION_ERROR.MAX_BELOW_MIN };

  return {
    valid: true,
    contributionMode: COLLECTION_CONTRIBUTION_MODE.FLEXIBLE_RANGE,
    isVoluntary: Boolean(isVoluntary),
    minContribution: centsToMoney(minCents),
    maxContribution: centsToMoney(maxCents),
  };
}

export function validateCollectionContributionAmount(collection, amount) {
  const amountCents = moneyToCents(amount);
  if (amountCents === null) {
    return { valid: false, error: COLLECTION_CONTRIBUTION_ERROR.AMOUNT_INVALID };
  }

  const config = getCollectionContributionConfig(collection);
  if (config.contributionMode === COLLECTION_CONTRIBUTION_MODE.FIXED) {
    return { valid: true, legacyFixedMode: true };
  }

  const minCents = moneyToCents(config.minContribution);
  const maxCents = moneyToCents(config.maxContribution);
  if (minCents === null || maxCents === null) {
    return { valid: false, error: COLLECTION_CONTRIBUTION_ERROR.AMOUNT_INVALID };
  }
  if (amountCents < minCents) {
    return { valid: false, error: COLLECTION_CONTRIBUTION_ERROR.AMOUNT_BELOW_MIN };
  }
  if (amountCents > maxCents) {
    return { valid: false, error: COLLECTION_CONTRIBUTION_ERROR.AMOUNT_ABOVE_MAX };
  }
  return { valid: true, amount: centsToMoney(amountCents) };
}
